const ArzeshhayeSazmani = () => {
  return (
    <>
      <ul>
        <li>
          مدنظر قراردادن دو اصل صداقت و اخلاق به صورت درست، عادلانه ومسئولانه
        </li>
        <li>
          احترام به همه کارکنان با احترام به حقوق انسانی و حفظ حریم خصوصی افراد
          و از بین بردن انواع و اشکال تبعیض و بوجود آوردن جایی عالی برای کار
        </li>
        <li>بهبود مستمر و نوآوری</li>
        <li>تمرکز بر مشتری با رفع نیازهای ابزاری و بیان نشده مشتری</li>
      </ul>
    </>
  );
};

export default ArzeshhayeSazmani;
